import { ArraySchema, EntitySchema } from 'Lib/schemas';

import { ARCHIVED_MATCHES_ENTITY_KEY } from 'Store/entities/entityKeys';
import { messageArray } from 'Store/entities/messages.schema';
import { profileEntity } from 'Store/entities/profiles.schema';

/**
 * Archived Match Entity
 * Stores all the Archived Matches returned from /v1/match-expiration/archived-matches
 * An archived match is a match that has expired and x days have passed,
 * moving it to a separate "Archived" list
 * ==============
 */
export const archivedMatchEntity = new EntitySchema(
  ARCHIVED_MATCHES_ENTITY_KEY,
  {
    messages: messageArray,
    person: profileEntity,
  },
  {
    idAttribute: '_id',
    processStrategy(value) {
      return value;
    },
  }
);

export const archivedMatchArray = new ArraySchema(archivedMatchEntity);
